import { http, ep } from '../../client/http';

export const sssRepo = {
  get: async () => {
    const res = await http.get(ep('faq/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
